import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE, connectRouter } from 'connected-react-router';

import { buildFullUrl } from 'app/router/helpers/buildUrl';
import { notFoundRoute } from 'app/router/actions';

const router = history => {
  const connectedRouterReducer = connectRouter(history);
  const initialState = {
    referrer: document.referrer,
    location: history.location,
    action: history.action,
    isNotFound: false,
  };

  return handleActions(
    {
      [LOCATION_CHANGE]: (state, action) => ({
        ...connectedRouterReducer(state, action),
        referrer: action.payload.isFirstRendering
          ? state.referrer
          : buildFullUrl(state.location),
        referrerURL: action.payload.isFirstRendering
          ? buildFullUrl(action.payload.location)
          : state.referrerURL,
      }),
      [notFoundRoute]: state => ({ ...state, isNotFound: true }),
    },
    initialState,
  );
};

export default router;
